import { Component, OnInit } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AppSession } from 'src/app/models/app-session';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

  minPasswordLength = AppSession.getPasswordPolicy().minLength;
  minPasswordUppercase = AppSession.getPasswordPolicy().minUppercase;
  minPasswordLowercase = AppSession.getPasswordPolicy().minLowercase;
  minPasswordDigits = AppSession.getPasswordPolicy().minDigits;
  minPasswordHistory = AppSession.getPasswordPolicy().minHistory;

  minPasswordLengthText = this.minPasswordLength;
  minPasswordUppercaseText = this.minPasswordUppercase;
  minPasswordLowercaseText = this.minPasswordLowercase;
  minPasswordDigitsText = this.minPasswordDigits;
  minPasswordHistoryText = this.minPasswordHistory;

  constructor(
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // if (this.translate.currentLang === 'en') {
        this.minPasswordLengthText = this.translate.instant('numbers.' + this.minPasswordLength);
        this.minPasswordUppercaseText = this.translate.instant('numbers.' + this.minPasswordUppercase);
        this.minPasswordLowercaseText = this.translate.instant('numbers.' + this.minPasswordLowercase);
        this.minPasswordDigitsText = this.translate.instant('numbers.' + this.minPasswordDigits);
        this.minPasswordHistoryText = this.translate.instant('numbers.' + this.minPasswordHistory);
      // }
    });
  }

}
